/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationBrandCatalogs200ResponseLocationBrandsInner } from './GetLocationBrandCatalogs200ResponseLocationBrandsInner';
import {
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerFromJSON,
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerFromJSONTyped,
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerToJSON,
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerToJSONTyped,
} from './GetLocationBrandCatalogs200ResponseLocationBrandsInner';
import type { GetLocationBrandCatalogs200ResponseCatalogsInner } from './GetLocationBrandCatalogs200ResponseCatalogsInner';
import {
    GetLocationBrandCatalogs200ResponseCatalogsInnerFromJSON,
    GetLocationBrandCatalogs200ResponseCatalogsInnerFromJSONTyped,
    GetLocationBrandCatalogs200ResponseCatalogsInnerToJSON,
    GetLocationBrandCatalogs200ResponseCatalogsInnerToJSONTyped,
} from './GetLocationBrandCatalogs200ResponseCatalogsInner';

/**
 * 
 * @export
 * @interface GetLocationBrandCatalogs200Response
 */
export interface GetLocationBrandCatalogs200Response {
    /**
     * 
     * @type {Array<GetLocationBrandCatalogs200ResponseLocationBrandsInner>}
     * @memberof GetLocationBrandCatalogs200Response
     */
    locationBrands: Array<GetLocationBrandCatalogs200ResponseLocationBrandsInner>;
    /**
     * 
     * @type {Array<GetLocationBrandCatalogs200ResponseCatalogsInner>}
     * @memberof GetLocationBrandCatalogs200Response
     */
    catalogs: Array<GetLocationBrandCatalogs200ResponseCatalogsInner>;
}

/**
 * Check if a given object implements the GetLocationBrandCatalogs200Response interface.
 */
export function instanceOfGetLocationBrandCatalogs200Response(value: object): value is GetLocationBrandCatalogs200Response {
    if (!('locationBrands' in value) || value['locationBrands'] === undefined) return false;
    if (!('catalogs' in value) || value['catalogs'] === undefined) return false;
    return true;
}

export function GetLocationBrandCatalogs200ResponseFromJSON(json: any): GetLocationBrandCatalogs200Response {
    return GetLocationBrandCatalogs200ResponseFromJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationBrandCatalogs200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'locationBrands': ((json['locationBrands'] as Array<any>).map(GetLocationBrandCatalogs200ResponseLocationBrandsInnerFromJSON)),
        'catalogs': ((json['catalogs'] as Array<any>).map(GetLocationBrandCatalogs200ResponseCatalogsInnerFromJSON)),
    };
}

export function GetLocationBrandCatalogs200ResponseToJSON(json: any): GetLocationBrandCatalogs200Response {
    return GetLocationBrandCatalogs200ResponseToJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseToJSONTyped(value?: GetLocationBrandCatalogs200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationBrands': ((value['locationBrands'] as Array<any>).map(GetLocationBrandCatalogs200ResponseLocationBrandsInnerToJSON)),
        'catalogs': ((value['catalogs'] as Array<any>).map(GetLocationBrandCatalogs200ResponseCatalogsInnerToJSON)),
    };
}

